import { render, staticRenderFns } from "./ThreatCanvasProperties.vue?vue&type=template&id=fa9edabe&scoped=true"
import script from "./ThreatCanvasProperties.vue?vue&type=script&lang=js"
export * from "./ThreatCanvasProperties.vue?vue&type=script&lang=js"
import style0 from "./ThreatCanvasProperties.vue?vue&type=style&index=0&id=fa9edabe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9edabe",
  null
  
)

export default component.exports